<ng-container *ngIf="group && field">

  <div class="main-outer-container " [formGroup]="group" [hidden]="field.hidden || false">

    <div *ngIf="field.type=='input'" class="flex flex-col align-top my-2">

      <label for="{{field!.name}}" class="label col-sm-3 col-form-label">{{field.label}}</label>

      <!--OLD [class]="group.controls[field!.name].dirty ? (group.controls[field.name].invalid ? 'danger' : 'success') : ''"
      [attr.aria-invalid]="group.controls[field.name].invalid && group.controls[field.name].touched
                    ? true : null" (change)="onChangeValue($event)"
      -->
      
        <input [matTooltip]="field.tooltip" #inputEl [id]="field.name" [readonly]="field.readonly || false" [hidden]="field.hidden ||  false"
          [formControlName]="field.name" class="e-input transform duration-300 {{field!.cssClass}} "
          [placeholder]="field.placeholder || '...'" [type]="field.inputType || 'text'" [value]="field.value || ''"
          (focus)="onFocus($event)" (change)="onChangeValue($event)" style="z-index: 99;" (keyup)="onKeyUp($event)">
    

    </div>

    <div *ngIf="field.type=='password'" class="flex flex-col align-top my-2">

      <label for="{{field!.name}}" class="label col-sm-3 col-form-label">{{field.label}}</label>

      <!--OLD [class]="group.controls[field!.name].dirty ? (group.controls[field.name].invalid ? 'danger' : 'success') : ''"
      [attr.aria-invalid]="group.controls[field.name].invalid && group.controls[field.name].touched
                    ? true : null" (change)="onChangeValue($event)"
      -->
    
        <div class="relative">
          <input [matTooltip]="field.tooltip" #inputEl id="pwdInput" [readonly]="field.readonly || false" [hidden]="field.hidden ||  false"
            [formControlName]="field.name" [ngClass]="'e-input transform duration-300 '+field!.cssClass "
            [placeholder]="field.placeholder || '...'" type="password" [value]="field.value || ''"
            (focus)="onFocus($event)" (change)="onChangeValue($event)" (keyup)="onKeyUp($event)">
          <div [class]="passwIcon" class="absolute top-0 right-0 pwdicon flex content-center items-center align-middle"
            (click)="showPassword()"></div>
        </div>


    </div>

    <div *ngIf="field.type=='color'" class="flex flex-col align-top my-2 {{field.cssClass}}">

      <label for="{{field!.name}}" [class]="'label col-sm-3 col-form-label '+field.cssClass">{{field.label}}</label>

      <!--OLD [class]="group.controls[field!.name].dirty ? (group.controls[field.name].invalid ? 'danger' : 'success') : ''"
      [attr.aria-invalid]="group.controls[field.name].invalid && group.controls[field.name].touched
                    ? true : null" (change)="onChangeValue($event)"
      -->

        <div class="relative">
          <input [matTooltip]="field.tooltip" #inputEl id="pwdInput" [readonly]="field.readonly || false" [hidden]="field.hidden ||  false"
            [formControlName]="field.name" [ngClass]="'w-full h-10 transform duration-300 '+field!.cssClass "
            [placeholder]="field.placeholder || '...'" type="color" (focus)="onFocus($event)"
            (change)="onChangeValue($event)" (keyup)="onKeyUp($event)">
        </div>


    </div>

    <div *ngIf="field.type =='file'" class="flex flex-col align-top my-2 {{field.cssClass}}">
      <label [matTooltip]="field.tooltip"  class="form-secondary-action-button dl-button w-full  rounded-lg shadow-lg "
        [ngClass]="{'dl-button-disabled cursor-not-allowed ': group.disabled,'dl-button cursor-pointer ': group.enabled}">
        <input class="hidden" #fileUpload id="fileUpload" type="file" [disabled]="group.disabled"
          [accept]="acceptedImages" [readonly]="field.readonly || false" (change)="loadLogoToBase64($event)">

        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
          class="w-6 h-6">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m6.75 12l-3-3m0 0l-3 3m3-3v6m-1.5-15H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
        </svg>

        {{uploadText}}
      </label>

      <div *ngIf="fileError" class=" p-2 flex justify-start items-center gap-2 bg-red-700/50 rounded-xl text-white font-bold">
        Il file supera la dimensione massima (10mb)
      </div>

      <div *ngIf="fileErrorType" class=" p-2 flex justify-start items-center gap-2 bg-red-700/50 rounded-xl text-white font-bold">
        Il file caricato non è nel formato corretto
      </div>

      <div *ngIf="value && value.length>0" class="card-primary mx-0 my-5 w-80">
        <img src="{{value}}" width="300px">
      </div>
      <!-- 
        <div *ngIf="valueSvg" [id]="field.name+'svgM'" class="card-primary mx-0 my-5 w-80" [innerHTML]="valueSvg">
        </div> -->


      <div *ngIf="valueSvg" [id]="field.name+'svgM'" class="card-primary mx-0 my-5 w-80">
      </div>

    </div>



    <!-- NUMBER +- INPUT  -->

    <div *ngIf="field.type=='numberInput'" class="flex flex-col align-top my-2">

      <label for="{{field!.name}}" class="label col-sm-3 col-form-label">{{field.label}}</label>

      <!--OLD [class]="group.controls[field!.name].dirty ? (group.controls[field.name].invalid ? 'danger' : 'success') : ''"
      [attr.aria-invalid]="group.controls[field.name].invalid && group.controls[field.name].touched
                    ? true : null" (change)="onChangeValue($event)"
      -->
      <div class="flex justify-between items-center w-full gap-2 bg-primary-50 user-card rounded-full p-2">

        <button type="button" class="p-2 dl-button  rounded-full" (click)="decrease()">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-6 h-6">
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M5 12l14 0" />
          </svg>
        </button>


          <input [matTooltip]="field.tooltip"  #inputEl [id]="field.name" [readonly]="field.readonly || false" [hidden]="field.hidden ||  false"
            [formControlName]="field.name" mask="0000000000000000000" [validation]="false"
            [ngClass]="' text-center bg-transparent  focus:border-none  focus:outline-none w-full h-full text-primary-500 text-2xl font-bold'+ ' ' +field!.cssClass "
            [placeholder]="field.placeholder || '...'" [type]="'text'" (focus)="onFocus($event)" (change)="onChangeValue($event)"
            style="z-index: 99;" (keyup)="onKeyUp($event)">


        <button type="button" class="p-2 dl-button rounded-full" (click)="increase()">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round" class="w-6 h-6">
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M12 5l0 14" />
            <path d="M5 12l14 0" />
          </svg>
        </button>

      </div>

    </div>

    <div *ngIf="field.message!=undefined">
      <p class="text-sm">{{field.message}}</p>
    </div>
    <!--OLD ngIf *ngIf="group.controls[field.name].dirty && group.controls[field.name].invalid"-->
    <div class="flex align-top flex-col gap-2"
      *ngIf="group.controls[field.name]?.dirty || group.controls[field.name]?.touched">
      <ng-container *ngFor="let validation of field!.validations;let i= index;">
        <!--<span *ngIf="group!.controls[field!.name].hasError(validation.name)"
              style="color: red;">{{validation.message}}&nbsp;&nbsp;</span>-->

        <div @slideDownUp *ngIf="group && field && group.controls[field.name].hasError(validation.name)"
          class=" p-2 flex justify-start items-center gap-2 bg-red-700/50 rounded-xl text-white font-bold">

          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round" class="w-6 h-6">
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0" />
            <path d="M12 8v4" />
            <path d="M12 16h.01" />
          </svg>

          <p>{{validation.message}}</p>
        </div>
      </ng-container>

    </div>

    <div @slideDownUp *ngIf="group && field && group.controls[field.name].hasError('highlight')"
      class=" p-2 flex justify-start items-center gap-2 bg-red-700/50 rounded-xl text-white font-bold">

      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
        stroke-linecap="round" stroke-linejoin="round" class="w-6 h-6">
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0" />
        <path d="M12 8v4" />
        <path d="M12 16h.01" />
      </svg>

      <p>{{group.controls[field.name].getError('highlight')}}</p>
    </div>


  </div>
</ng-container>